module.exports = __webpack_public_path__ + "img/iglu.826352b2.png";